import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InvalidStateError } from '../error';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  downloadFileFromResponse(response: HttpResponse<Blob>): void {
    const filename = response.headers.get('filename');
    if (!response.body || !filename) {
      throw new InvalidStateError('response incomplete');
    }
    const link = document.createElement('a');
    const url = URL.createObjectURL(response.body);
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
    link.remove();
  }

  downloadFile(data: Blob, filename: string): void {
    const link = document.createElement('a');
    const url = URL.createObjectURL(data);
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
    link.remove();
  }
}
